import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { TextAlignKinds } from "../../../../base/domain/drawing";
import { IComboSelectBehavior, TranscribeTargetKinds, IQuestionnaire, QuestionnaireType } from "../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { IComboObject } from "../objects";
import { IComboSelectBehaviorPropertyEditable, IQuestionnairePropertyEditable } from "../properties";
import { AbstractSelectableObjectEditor } from "./AbstractSelectableObjectEditor";

export class ComboObjectEditor extends AbstractSelectableObjectEditor<IComboObject> implements IComboSelectBehaviorPropertyEditable, IQuestionnairePropertyEditable {
  constructor(source: IComboObject | ComboObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._comboSelectBehavior = this.createPropertyEditor(s => s.comboSelectBehavior, (s, v) => s.comboSelectBehavior = v);
    this._questionnaire = this.createPropertyEditor(s => s.questionnaire, (s, v) => s.questionnaire = v);
  }

  protected _comboSelectBehavior: IPropertyEditable<IComboSelectBehavior>;
  protected _questionnaire: IPropertyEditable<IQuestionnaire>;

  comboSelectBehavior(): IPropertyEditable<IComboSelectBehavior> {
    return this._comboSelectBehavior;
  }

  questionnaire(): IPropertyEditable<IQuestionnaire> {
    return this._questionnaire;
  }

  selectableQuestionnaireTypes(): (QuestionnaireType | undefined)[] {
    return [
      undefined,
      "choice",
    ];
  }

  getTypeName(): string {
    return "リスト選択";
  }

  getSelectableAlignmentKinds(): TextAlignKinds[] {
    return this._specification.objects.combo.alignmentKinds;
  }

  getSelectableTranscribeTargets(): TranscribeTargetKinds[] {
    return this._specification.objects.combo.transcription.targets;
  }

  clone(): IFormatObjectEditable {
    return new ComboObjectEditor(this);
  }
}
